import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	clearSelection: {
		id: `eoc.alert-list.common.generic-select.footer.clear-selection`,
		defaultMessage: 'Clear selection',
		description: 'The label of clear selection button',
	},
	showFullList: {
		id: `eoc.alert-list.common.generic-select.footer.show-full-list`,
		defaultMessage: 'Show full list',
		description: 'The label of show full list button',
	},
});

export default messages;
